export default __webpack_public_path__ + "static/media/launch-coin.601f5542.svg";